module.exports = __webpack_public_path__ + "static/media/Alaska_991.9f620d84.png";